import React, { Fragment, Component } from 'react';
import { bool, arrayOf, string, object, oneOfType, number } from 'prop-types';
import { Input, Select } from 'common/components';
import { OPTIONS, CROP_SIZE } from 'common/constants';
import {
  maxValue,
  maxLength,
  minValue,
  required,
  numberOnly,
  noPercent,
} from 'common/form-validators';
import { capitalizeString } from 'common/utils';
import * as normalizers from 'common/normalizers';
import { toCommaNumber, shortenFormat } from 'common/formatters';
import SectionTitle from '../components/SectionTitle';

class SeedingFields extends Component {
  constructor(props) {
    super(props);

    // validations
    this.farmSizeMin = value => minValue(value, CROP_SIZE.MIN);
    this.varietyMax = value => maxLength(value, CROP_SIZE.MAX_TITLE);

    // normlizers
    this.normalizeFarmSize = value =>
      normalizers.limitDigits(normalizers.onlyNumbers(value), 13, 2);
    this.shortenFormat = value =>
      shortenFormat(value, CROP_SIZE.MAX_TITLE_SHORTEN);
  }

  static propTypes = {
    submitting: bool,
    plantedArea: oneOfType([string, number]),
    crops: arrayOf(object),
    selectedCrop: string,
    isEdit: bool,
  };

  plantedAreaMax = value => {
    const max = this.props.plantedArea;
    return (
      maxValue(value, max) &&
      `Only ${max} Acres available on this field, try again`
    );
  };

  cropNameTaken = value => {
    const { crops, selectedCrop } = this.props;
    let match =
      crops &&
      crops.filter(
        crop => crop.crop.name === selectedCrop && crop.crop.variety === value
      );
    return match && match.length > 0
      ? `"${selectedCrop} ${value}" already exists`
      : undefined;
  };

  render() {
    const { submitting, isEdit } = this.props;
    const cropOption = OPTIONS.CROP_OPTIONS.map(({ label, value }) => ({
      label,
      value: JSON.stringify({
        name: value,
        variety: null,
        __typename: 'CropIdentifier',
      }),
    }));

    return (
      <Fragment>
        <Select
          name="crop"
          disabled={submitting || isEdit}
          title="Crop"
          options={cropOption}
          validate={[required]}
        />
        <Input
          name="variety"
          disabled={submitting || isEdit}
          title="VARIETY"
          normalize={capitalizeString}
          normalizeOnBlur={normalizers.trim}
          validate={[this.varietyMax, noPercent, this.cropNameTaken]}
        />
        <Input
          name="plantedArea"
          disabled={submitting}
          title="PLANTED AREA"
          infoText="ACRES"
          validate={[
            required,
            numberOnly,
            this.farmSizeMin,
            this.plantedAreaMax,
          ]}
        />
        <Input
          name="expectedYield"
          disabled={submitting}
          title="EXPECTED YIELD"
          infoText="BUSHEL/ACRE"
          validate={[required]}
          normalize={this.normalizeFarmSize}
          format={toCommaNumber}
        />
        <Input
          name="seedingRate"
          disabled={submitting}
          title="SEEDING RATE"
          infoText="SEEDS/ACRE"
          normalizeOnBlur={normalizers.trim}
        />
        <SectionTitle title="Seed Treatment" required={false} />
        <Input
          name="chemical"
          disabled={submitting}
          title="CHEMICAL"
          normalizeOnBlur={normalizers.trim}
        />
        <Input
          name="inoculant"
          disabled={submitting}
          title="INOCULANT"
          normalizeOnBlur={normalizers.trim}
        />
      </Fragment>
    );
  }
}

export default SeedingFields;



// WEBPACK FOOTER //
// ./src/containers/ActivityForm/fields/SeedingFields.js